export default "__VITE_PUBLIC_ASSET__c4e4e28a__"